"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExportPostalCodeColumnLabel = exports.getExportRegionColumnLabel = void 0;
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
const getExportRegionColumnLabel = (locale, country) => {
    if (country === country_1.OrganizationCountry.Australia && locale === locales_1.Locales.EN) {
        return "State/Territory";
    }
    switch (locale) {
        case locales_1.Locales.FR:
            return "Région";
        case locales_1.Locales.ES:
            return "Región";
        default:
            return "Region";
    }
};
exports.getExportRegionColumnLabel = getExportRegionColumnLabel;
const getExportPostalCodeColumnLabel = (locale, country) => {
    if (country === country_1.OrganizationCountry.Australia && locale === locales_1.Locales.EN) {
        return "Postcode";
    }
    switch (locale) {
        case locales_1.Locales.FR:
            return "Code postal";
        case locales_1.Locales.ES:
            return "Código postal";
        default:
            return "Postal code";
    }
};
exports.getExportPostalCodeColumnLabel = getExportPostalCodeColumnLabel;
